module.exports = __webpack_public_path__ + "img/logo.8d493973.png";